import Constant from '@/common/constant/Constant';
import trI18n from '@/common/utils/trI18n';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { Storage } from 'aws-amplify';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

const normalizeAssistantMarkdownForList = (message = '') => {
    if (Utils.isEmptyString(message)) return '';

    // Only normalize the AI Assistant combined response format to avoid side effects
    const isAssistantCombinedResponse =
        message.includes(Constant.ANSWER) && message.includes('ーーーーーーーーー');

    if (!isAssistantCombinedResponse) {
        return message;
    }

    return message
        .replace(/\[(.*?)\]\((.*?)\)/g, '$1')
        .replace(/\*\*(.*?)\*\*/g, '$1')
        .replace(/__(.*?)__/g, '$1')
        .replace(/`([^`]+)`/g, '$1')
        .replace(/~~(.*?)~~/g, '$1')
        .replace(/[\r\n]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};

export const getTicketStorageData = async ticketDetail => {
    let ticket = cloneDeep(ticketDetail);
    let userNoticeImage = ticket.affiliationProjectInfo?.userNoticeImage;
    let avatar = userNoticeImage;
    if (userNoticeImage) {
        if (userNoticeImage !== Constant.AVATAR_DEFAULT) {
            avatar = await Storage.get(userNoticeImage);
        } else {
            avatar = '';
        }
        ticket.affiliationProjectInfo.image = avatar;
    }

    if (!Utils.isEmpty(ticket.lastMessageInfo)) {
        let userDetail = !ticket.lastMessageInfo?.userDetail || Utils.isEmpty(ticket.lastMessageInfo?.userDetail)
            ? {}
            : Utils.convertJSONDataToObject(ticket.lastMessageInfo.userDetail);
        let fullName = Utils.getUserNameWithActiveStatus(userDetail);
        let shortFullName = Utils.isEmptyString(fullName) ? '' : fullName.substring(0, 2);
        ticket.lastMessageInfo.fullName = fullName;
        ticket.lastMessageInfo.shortFullName = shortFullName;
        // call s3
        if (ticket.lastMessageInfo.avatar !== Constant.AVATAR_DEFAULT) {
            // use S3Image tag
            // let avatar = await Storage.get(ticket.lastMessageInfo.avatar);
            // ticket.lastMessageInfo.avatar = avatar;
            ticket.lastMessageInfo.shortFullName = '';
        }

        // Voice customer in app integration ticket: show default avatar img, tooltip only
        if (
            Utils.isAppIntegrationTicket(ticket) &&
            userDetail?.id === TelephoneConstant.CUSTOMER.KEY
        ) {
            ticket.lastMessageInfo.shortFullName = '';
        }

        // build messsage
        let message = ticket.lastMessageInfo.message;
        switch (ticket.lastMessageInfo.message) {
            case Constant.POST_TYPE.IMAGE:
                message = trI18n('USER04MSG021');
                break;
            case Constant.POST_TYPE.FILE:
                message = trI18n('USER04MSG020');
                break;
            default:
                message = normalizeAssistantMarkdownForList(message);
                break;
        }
        ticket.lastMessageInfo.message = message;
    }

    // Get avatar of assignee
    if (!Utils.isEmptyObject(ticket?.personInChargeInfo) && ticket?.personInChargeInfo?.avatar) {
        let assignAvatar = await Storage.get(ticket?.personInChargeInfo?.avatar);
        ticket.personInChargeInfo.avatar = assignAvatar;
    }
    return ticket;
};

export const isQaAnonymousFromIframeOrChatBotApprovedAndCusInviteSettingOff = (projectDetail, detailTicket) => {
    let isCustomerInvitationSettingOff = detailTicket?.anonymousUserInfo?.isCustomerInvitationSettingOff;
        
    if (
        Utils.isAnonymousQAApproveTicket(detailTicket) &&
        isCustomerInvitationSettingOff &&
        (Utils.isAnonymousQATicketFromIframe(detailTicket) ||
            Utils.isAnonymousQATicketFromChatBotAndFinish(detailTicket))
    ) {
        return true;
    }
    return false;
}
